module.exports = __webpack_public_path__ + "static/img/banner-text.a455aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-text.png
// module id = gLvS
// module chunks = 1